import { CSSProperties, FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  /** CSS length for the loader width (the mark is 20:14). */
  size?: string;
  /** Center in the viewport (default). Pass false when rendering inline inside a card. */
  fullscreen?: boolean;
  /**
   * - `assemble` (default): strokes drop onto a faint outline, a light crosses, they sink away.
   * - `flow`: colour runs through the strokes in writing order. The calmest; suits long waits and inline text.
   * - `flip`: each stroke turns on its own spine. Needs about 28px to read, so keep it out of buttons.
   */
  variant?: "assemble" | "flow" | "flip";
};

// The AptEdge mark as five strokes. Their shapes and motion live in styles.module.scss.
const STROKES = [0, 1, 2, 3, 4].map((i) => <i key={i} />);

// ponytail: kept the DotLoader name and data-testid so 12 call sites and ~20 test
// assertions stay untouched. Rename when the codebase does a loader sweep.
const DotLoader: FC<Props> = ({
  size = "2.5rem",
  fullscreen = true,
  variant = "assemble"
}) => {
  // A span, so it stays valid inside a button or a line of text.
  const loader = (
    <span
      role="status"
      aria-label="Loading"
      data-testid="dot-loader"
      className={`${styles.loader} ${styles[variant]}`}
      style={{ "--size": size } as CSSProperties}
    >
      {variant !== "flip" && <span className={styles.outline}>{STROKES}</span>}
      {STROKES}
    </span>
  );

  return fullscreen ? (
    <div className={styles.fullscreen}>{loader}</div>
  ) : (
    loader
  );
};

export default DotLoader;
